import { CapoPlugin } from "/data/node-v18/workspace/djt-h5/h5-support-Nuxt-fra-prod/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];